<template>
  <v-container>
    <v-row justify="center" wrap>
      <v-col class="text-center" cols="12">
        <div class="title">
          Launch a Client
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="10" lg="6">
        <v-text-field v-model="clientId" label="Client Id" type="number">
          <template slot="append-outer">
            <v-btn text :to="clientPath">
              Launch
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  data: function () {
    return {
      clientId: null
    };
  },
  computed: {
    environment () {
      return localStorage.getItem('environment');
    },
    clientPath () {
      return `client/${this.clientId}`;
    }
  },
  methods: {
    navigate () {
      analyticsService.sendEvent(this.$gtag, 'Launch Client', 'Search', 'Launch Client by ID');
      this.$router.push(this.clientPath);
    }

  }
};
</script>
